import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useLogin } from '../lib/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const login = useLogin();
  const nav = useNavigate();
  const [params] = useSearchParams();
  // next=... is set by RequireAuth + api.js apiFetch on 401 so login bounces
  // back to the originally-requested page. Default to / for direct visits.
  const next = params.get('next') || '/';

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    try {
      await login.mutateAsync({ username, password });
      nav(next, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="card w-full max-w-sm p-6 sm:p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="w-12 h-12 rounded bg-sentinel-navy flex items-center justify-center font-bold text-white text-lg mb-3">
            SQ
          </div>
          <h1 className="font-semibold text-lg text-sentinel-navy">Sentinel Quoting Pipeline</h1>
          <div className="text-sm text-slate-500">ops dashboard</div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-slate-700 mb-1">
              Username
            </label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              required
              autoFocus
              value={username}
              onChange={e => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded focus:outline-none focus:ring-2 focus:ring-tint focus:border-transparent"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-slate-700 mb-1">
              Password
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-slate-300 rounded focus:outline-none focus:ring-2 focus:ring-tint focus:border-transparent"
            />
          </div>

          <button
            type="submit"
            disabled={login.isPending}
            className="w-full py-2 rounded bg-tint text-on-tint font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {login.isPending ? 'Signing in…' : 'Sign in'}
          </button>

          {error && (
            <div className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded px-3 py-2">
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
